/**
 * Draggable camera preview component for Proctoring SDK
 * Shows user's camera feed in a floating window
 */

class CameraPreview {
    element = null;
    shadowRoot = null;
    videoElement = null;
    isDragging = false;
    dragOffset = { x: 0, y: 0 };
    options = {
        position: "bottom-right",
    };

    init(shadowRoot, options = {}) {
        this.shadowRoot = shadowRoot;
        this.options = { ...this.options, ...options };

        this.element = document.createElement("div");
        this.element.className = `camera-preview pos-${this.options.position}`;

        this.element.innerHTML = `
            <video autoplay playsinline muted></video>
        `;

        this.videoElement = this.element.querySelector("video");

        // Drag functionality - entire circle is draggable
        this.element.addEventListener("mousedown", (e) => this.startDrag(e));
        document.addEventListener("mousemove", (e) => this.drag(e));
        document.addEventListener("mouseup", () => this.stopDrag());

        // Touch support
        this.element.addEventListener(
            "touchstart",
            (e) => this.startDrag(e.touches[0]),
            { passive: true },
        );
        document.addEventListener("touchmove", (e) => this.drag(e.touches[0]), {
            passive: true,
        });
        document.addEventListener("touchend", () => this.stopDrag());

        this.shadowRoot.appendChild(this.element);
        this.element.style.display = "none";
    }

    startDrag(e) {
        this.isDragging = true;
        const rect = this.element.getBoundingClientRect();
        this.dragOffset = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        };
        this.element.style.transition = "none";
    }

    drag(e) {
        if (!this.isDragging) return;

        const x = e.clientX - this.dragOffset.x;
        const y = e.clientY - this.dragOffset.y;

        // Keep within viewport
        const maxX = window.innerWidth - this.element.offsetWidth;
        const maxY = window.innerHeight - this.element.offsetHeight;

        this.element.style.left = `${Math.max(0, Math.min(x, maxX))}px`;
        this.element.style.top = `${Math.max(0, Math.min(y, maxY))}px`;
        this.element.style.right = "auto";
        this.element.style.bottom = "auto";
    }

    stopDrag() {
        this.isDragging = false;
        this.element.style.transition = "";
    }

    setStream(stream) {
        if (this.videoElement && stream) {
            this.videoElement.srcObject = stream;
        }
    }

    show() {
        this.element.style.display = "";
    }

    hide() {
        this.element.style.display = "none";
    }

    toggle() {
        if (this.element.style.display === "none") {
            this.show();
        } else {
            this.hide();
        }
    }

    destroy() {
        if (this.videoElement) {
            this.videoElement.srcObject = null;
        }
        this.element?.remove();
        this.element = null;
        this.videoElement = null;
    }
}

export default new CameraPreview();
